import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">{t('notFound.title')}</h1>
        <h2 className="not-found-subtitle">{t('notFound.message')}</h2>
        <p className="not-found-message">
          {t('notFound.description')}
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn-primary">
            {t('notFound.backHome')}
          </Link>
          <Link to="/dashboard" className="btn-secondary">
            {t('notFound.dashboard')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
